//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { datesToHuman, VistatDate } from "../utils/dates.js";
import TheSwitch from "@/components/objects/public/TheSwitch.vue";
import TheSelect from "@/components/TheSelect.vue";
import { moment } from "~/plugins/moment";

export default {
  name: "TheDatePicker",
  components: { TheSwitch, TheSelect },
  props: {
    from: {
      type: Object,
      default: () => {
        return {
          value: '',
          is_approx: false
        }
      }
    },
    to: {
      type: Object,
      default: () => {
        return {
          value: '',
          is_approx: false
        }
      }
    }
  },
  emits: ['validate', 'update', 'input'],
  data() {
    return {
      fromDate: {
        date: undefined,
        month: undefined,
        year: undefined,
        datetime: null,
        is_approx: this.from.is_approx,
        beforeNewEpoch: false
      },
      toDate: {
        date: undefined,
        month: undefined,
        year: undefined,
        datetime: null,
        is_approx: this.from.is_approx,
        touched: false,
        beforeNewEpoch: false
      },
      daysInMonthFrom: [],
      daysInMonthTo: [],
      computedDates: '',
      addedPeriod: false,
      openedAdditionFieldsFrom: false,
      openedAdditionFieldsTo: false,
      error: false,
      vistatFrom: new VistatDate(),
      vistatTo: new VistatDate(undefined, undefined, undefined, false),
      vistatFromRepr: {},
      vistatToRepr: {},
      untilNow: false,
      useTime: false,
      timePick: null
    }
  },
  computed: {
    monthsList() {
      return moment.months().map((val, index) => {
        return {
          id: index.toString(),
          label: val
        }
      })
    },
    fromParsedValue: {
      get() {
        const result = {
          date: null,
          month: null,
          year: null,
          datetime: null,
          is_approx: this.from.is_approx
        }

        if (this.from.value.startsWith('-')) {
          Object.assign(result, { year: Math.abs(parseInt(this.from.value) ?? 0) })
        }

        if (this.from.value) {
          const format = 'YYYY.MM.DD HH:mm:ss'
          const parsed = moment(this.from.value, format)

          if (parsed.isValid()) {
            Object.assign(result, {
              date: parsed.date(),
              month: parsed.month(),
              year: parsed.year(),
              datetime: parsed
            })
          }
        }

        return result
      },
      set: function (value) {
        const payload = {
          ...this.fromParsedValue,
          ...value
        }

        if (payload.year >= 0) {
          // Обработка нашей эры
          const datetime = (payload.datetime ?? moment())
          datetime.year(payload.year)

          if (payload.month === null) {

          }

          this.$emit(`update:from`, {
            value: (payload.datetime ?? moment()).year(payload.year).month(payload.month ?? 0).date(payload.date ?? 1).format('YYYY.MM.DDTHH:mm:ss'),
            is_approx: payload.is_approx
          })
        }
      }
    },
    isStaging() {
      return process.env.isStaging
    },
    isShowUseCheckTimePicker(){
      return !(this.vistatFromRepr.day === undefined)
        && !(this.vistatFromRepr.day === null)
        && !this.vistatToRepr.isBCE
        && !this.untilNow
        && !this.addedPeriod
    },
    isShowUseTimePicker(){
      return this.useTime
    },
    isShowTimeLabel(){
      return this.isShowUseCheckTimePicker && this.useTime && this.timePick;
    },
    showValTimePick(){
      if (!this.timePick || !this.timePick.isValid || !this.timePick.isValid()) {
        return null;
      }

      const hours = this.timePick.hours();
      const minutes = this.timePick.minutes();
      const formattedTime = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;

      return formattedTime;
    },
  },
  watch: {
    vistatFrom: {
      deep: true,
      handler() {
        this.vistatFromRepr = this.vistatFrom.toRepresentation()
        if (!this.vistatFromRepr.isBCE && !isNaN(this.vistatFrom.year) && this.vistatFrom.hasDate()) {
          this.daysInMonthFrom = Array(this.vistatFrom.getMomentJsInstance().daysInMonth()).fill(0).map((x, index) => {
            return {
              id: index + 1,
              label: index + 1
            }
          })
        } else {
          this.daysInMonthFrom = []
        }

        this.updatePreviewDates()
      }
    },
    vistatTo: {
      deep: true,
      handler() {
        this.vistatToRepr = this.vistatTo.toRepresentation()
        if (!this.vistatToRepr.isBCE && !isNaN(this.vistatTo.year) && this.vistatTo.hasDate()) {
          this.daysInMonthTo = Array(this.vistatTo.getMomentJsInstance().daysInMonth()).fill(0).map((x, index) => {
            return {
              value: index + 1,
              label: index + 1
            }
          })
        } else {
          this.daysInMonthTo = []
        }
        this.updatePreviewDates()
      }
    }
  },
  created() {
    if (this.from.value) {
      this.vistatFrom.parseString(this.from.value)

      const dateTime = moment(this.from.value, 'YYYY.MM.DDTHH:mm:ss')
      this.useTime = !(dateTime.format('HH:mm') === '00:00')

      if(this.useTime){
        this.timePick = dateTime
      }
    }
    if (this.to.value) this.vistatTo.parseString(this.to.value)

    if (this.vistatTo.hasDate() && !this.vistatTo.isSame(this.vistatFrom)) {
      this.vistatTo.touched = true
    }

    // Открываем блоки, что начальные даты до нашей эры
    if (this.vistatFrom.dateIsBCE()) this.openedAdditionFieldsFrom = true
    if (this.vistatTo.dateIsBCE() && !this.vistatFrom.isSame(this.vistatTo)) this.openedAdditionFieldsTo = true

    // Показываем форму с выбором периода, если есть какая-то конечная дата
    if (this.vistatTo.hasDate() && !this.vistatFrom.isSame(this.vistatTo)) this.addedPeriod = true

    if (this.to.value === null) this.setUntilNow()
  },
  methods: {
    searchFunctionDay(dayVal) {
      console.log(dayVal);
    },
    handleChangeYearFrom(year) {
      this.vistatFrom.setYear(parseInt(year))
      if (!this.vistatTo.touched && !this.untilNow) this.vistatTo.sinkIntervalWith(this.vistatFrom)
    },
    handleChangeMonthFrom(month) {
      const newVal = parseInt(month)
      this.vistatFrom.setMonth(Number.isInteger(newVal) ? newVal : undefined)
      if (!this.vistatTo.touched && !this.untilNow) this.vistatTo.sinkIntervalWith(this.vistatFrom)
    },
    handleChangeDateFrom(date) {
      console.log(date);

      this.vistatFrom.setDay(date ?? undefined)
      if (!this.vistatTo.touched && !this.untilNow) this.vistatTo.sinkIntervalWith(this.vistatFrom)
    },
    handleChangeDateTo(val) {
      return this.vistatTo.setDay(val ?? undefined)
    },
    handleChangeMonthTo(month) {
      const newVal = parseInt(month)
      return this.vistatTo.setMonth(Number.isInteger(newVal) ? newVal : undefined)
    },
    handleChangeYearTo(val) {
      return this.vistatTo.setYear(parseInt(val))
    },
    handleTogglePeriod() {
      if (!this.addedPeriod) {
        this.addedPeriod = true
        if (this.vistatTo.hasDate() && this.vistatTo.dateIsBCE()) this.openedAdditionFieldsTo = true

        if (this.vistatTo.hasDate()) {
          this.vistatTo.touched = true
          this.vistatTo.day = undefined
        }

      } else {
        this.clearToDate()
        this.vistatTo.sinkIntervalWith(this.vistatFrom)
      }
    },
    handleChangeBeforeEpochFrom(val) {
      const newEpochVal = val || !this.vistatFrom.isBCE

      if (!newEpochVal) {
        // Сброс даты до текущего года при переходе к нашей эре
        if (this.vistatFrom.hasDate() && this.vistatFrom.year > 9999) {
          this.vistatFrom.reset()
          this.vistatTo.reset()
          this.vistatFrom.setYear(new Date().getFullYear())
        }
      }

      this.vistatFrom.setEpoch(newEpochVal)

      if (newEpochVal && this.addedPeriod) this.openedAdditionFieldsTo = true

      if (!this.vistatTo.touched && !this.untilNow) this.vistatTo.sinkIntervalWith(this.vistatFrom)

      if (this.openedAdditionFieldsTo && this.vistatFrom.dateIsBCE()) {
        /* Если окно переода открыто, переводим его в режим до н.э*/
        this.handleChangeBeforeEpochTo(true)
      }
    },
    handleChangeBeforeEpochTo(val) {
      const newEpochVal = val || !this.vistatTo.isBCE

      if (!newEpochVal) {
        // Сброс даты до текущего года при переходе к нашей эре
        if (this.vistatTo.hasDate() && this.vistatTo.year > 9999) this.vistatTo.reset()
      }
      this.vistatTo.setEpoch(newEpochVal)

      if (this.vistatTo.isBCE) {
        this.vistatFrom.setEpoch(true)
        this.openedAdditionFieldsFrom = true
      }
    },
    getVistatFromFormat(){
      let timeString = "00:00:00";
      if (!(!this.timePick || !this.timePick.isValid || !this.timePick.isValid())) {
        const hours = this.timePick.hours();
        const minutes = this.timePick.minutes();
        timeString = `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}:00`;
      }

      return ((this.vistatFrom.datetime ?? moment()).year(this.vistatFrom.year).month(this.vistatFrom.month).date(this.vistatFrom.day).format('YYYY.MM.DD')) + "T" + timeString;
    },
    checkValidate() {
      const result = {
        event_from: {
          value: !this.isShowTimeLabel ? this.vistatFrom.toString() : this.getVistatFromFormat(),
          is_approx: false
        },
        event_to: {
          value: this.untilNow ? null : this.vistatTo.toString(),
          is_approx: false
        }
      }
      let invalid = false

      if (this.vistatFrom.year === undefined) return ['Укажите год']
      if (this.vistatFrom.year === 0 || this.vistatTo.year === 0) return ['Нельзя указать нулевой год']

      if (this.vistatFrom.dateIsBCE() && this.vistatFrom.year > 13820000000) {
        return ['Общепризнанный возраст вселенной 13,799 ± 0,021 миллиарда лет']
      }
      if (
        (this.vistatFrom.dateIsCE() && this.vistatFrom.year > 9999) ||
        (this.vistatTo.hasDate() && this.vistatTo.year > 9999 && this.vistatTo.dateIsCE())) {
        return ['Слишком далекое будущее']
      }
      if (this.vistatTo.year === undefined) {
        // второй диапазон явно не задан, присваиваем обеим границам одинаковое значение
        result.event_from.value = !this.isShowTimeLabel ? this.vistatFrom.toString() : this.getVistatFromFormat()
        result.event_to.value = this.untilNow ? null : (!this.isShowTimeLabel ? this.vistatFrom.toString() : this.getVistatFromFormat())
        return [false, result]
      } else {
        // Второй диапазон выбран как "до"
        if (this.vistatTo.dateIsBCE()) {
          if (this.vistatTo.isAfter(this.vistatFrom)) {
            return ['Год "до" должен быть больше']
          } else {
            return [invalid, result]
          }
        } else {
          if (this.vistatFrom.isAfter(this.vistatTo)) {
            return ['Начало периода должно быть меньше']
          } else {
            // if (this.vistatFrom.isSame(this.vistatTo)) result.event_to.value = null

            return [false, result]
          }
        }
      }
    },
    clearToDate() {
      this.addedPeriod = false
      this.openedAdditionFieldsTo = false
      this.useTime = false
      this.timePick = null
      this.vistatTo.reset()
    },
    setDayShortCut(offset = 0) {
      const targetDate = moment().add(offset, 'days')
      Object.assign(this.vistatFrom, {
        year: targetDate.year(),
        month: targetDate.month(),
        day: targetDate.date(),
        isBCE: false
      })
      this.clearToDate()
    },
    save() {
      const [hasError, result] = this.checkValidate()
      if (!hasError) {
        this.error = ""
        this.$emit('update', result)
        return result
      } else {
        this.$emit('validate', false)
        this.error = hasError
      }
    },
    setUntilNow() {
      this.untilNow = true;
      this.openedAdditionFieldsFrom = true
      this.clearToDate()
    },
    unsetUntilNow() {
      this.untilNow = false;
      this.vistatTo.sinkIntervalWith(this.vistatFrom)
    },
    toggleUntilNow() {
      if (this.untilNow) {
        this.unsetUntilNow()
      } else {
        this.setUntilNow()
      }
    },
    updatePreviewDates() {
      if (this.vistatFrom.year === undefined) return false
      this.computedDates = datesToHuman(
        {
          value: this.vistatFrom,
          approx: this.fromDate.is_approx,
        },
        {
          value: this.untilNow ? null : this.vistatTo,
          approx: this.toDate.is_approx
        })

      const [hasError, result] = this.checkValidate()
      if (!hasError) {
        this.error = ""
        this.$emit('input', result)
        return result
      }
    }
  }
}
